function isInside (point, polygon) {
  const x = point[0], y = point[1]

  let inside = false
  for (let i = 0, j = polygon.length - 1; i < polygon.length; j = i++) {
    const xi = polygon[i][0], yi = polygon[i][1]
    const xj = polygon[j][0], yj = polygon[j][1]

    let intersect = ((yi > y) !== (yj > y)) && (x < (xj - xi) * (y - yi) / (yj - yi) + xi)
    if (intersect) {
      inside = !inside
    }
  }

  return inside
}

export function isInsideBoundary (point, polygons) {
  return polygons.some(polygon => isInside(point, polygon))
}

export function getBoundaryAltitude (point, polygons) {
  for (let i = 0; i < polygons[i]; i++) {
    if (isInside(point, polygons[i])) {
      return polygons[i][0][2]
    }
  }
}

function distanceXY (p1, p2) {
  return Math.sqrt((p1[0] - p2[0]) * (p1[0] - p2[0]) + (p1[1] - p2[1]) * (p1[1] - p2[1]))
}

export function closestPoint (point, points, radius) {
  let minDistance = 1e10, minIndex = 0
  for (let i = 0; i < points.length; i++) {
    const distance = distanceXY(point, points[i])
    if (distance < minDistance) {
      minDistance = distance
      minIndex = i
    }
  }

  if (minDistance < radius) {
    return points[minIndex]
  } else {
    return null
  }
}

export function calculateTargetPoint (point, angle, distance) {
  const angleRad = angle * Math.PI / 180
  const targetX = point[0] + distance * Math.cos(angleRad)
  const targetY = point[1] + distance * Math.sin(angleRad)
  return [targetX, targetY]
}
